import { useState } from 'react'
import { zodResolver } from "@hookform/resolvers/zod";
import { useNavigate } from 'react-router-dom'
import { useResetPassword } from "@nhost/react";
import { ArrowLeft } from "lucide-react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { z } from "zod";
import { toast } from "sonner";

import { Button, buttonVariants } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";

const formSchema = z.object({
  email: z.string().email(),
});

export default function ForgotPassword() {
  const navigate = useNavigate()
  const { resetPassword } = useResetPassword({
    redirectTo: "/reset-password",
  });

  const [message, setMessage] = useState<string | null>(null)

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (values: z.infer<typeof formSchema>) => {
    const { email } = values;
    const result = await resetPassword(email);

    if (result.isError) {
      toast.error(result.error?.message);
    } else {
      toast.success("A link to reset your password has been sent by email");
      setMessage("Vous allez recevoir un lien à votre adresse email pour réinitialiser votre mot de passe.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center w-screen min-h-screen bg-gray-100">
      <div className="flex flex-col items-center justify-center w-full max-w-md p-8 bg-white rounded-md shadow">
        <h1 className="mb-8 text-4xl">Mot de passe oublié.</h1>
        <Form {...form}>
          {!message && (<form
            onSubmit={form.handleSubmit(onSubmit)}
            className="flex flex-col w-full space-y-4"
          >
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <Input placeholder="email" type="email" {...field} />
                  </FormControl>
                  <FormMessage className="text-xs" />
                </FormItem>
              )}
            />
            <Button type="submit">Réinitialiser mon mot de passe</Button>
          </form>
          )}
          {message && (
                        <p
                          className='text-green-600'>
                          {message}
                        </p>
                      )}

          <Separator className="my-2" />

          <Link to="/sign-in" className={buttonVariants({ variant: "link" })}>
            <ArrowLeft className="w-4 h-4" />
            Se connecter avec email + mot de passe
          </Link>
        </Form>
      </div>
    </div>
  );
}
